import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import documentosData from "./data/documentos_clasificado.json";
import dayjs from "dayjs";

const DocumentacionCarga = () => {
  const navigate = useNavigate();

  const [descripcionServicio, setDescripcionServicio] = useState("");
  const [alcanceServicio, setAlcanceServicio] = useState("");
  const [formaJuridica, setFormaJuridica] = useState("");
  const [documentosFiltrados, setDocumentosFiltrados] = useState({ empresa: [], trabajadores: [], vehiculos: [], equipos: [] });
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [enviando, setEnviando] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [erroresDocumentos, setErroresDocumentos] = useState({});
  const [formTouched, setFormTouched] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);

  useEffect(() => {
    const trabajadores = JSON.parse(localStorage.getItem("recursosTrabajadores") || "[]");
    const vehiculos = JSON.parse(localStorage.getItem("recursosVehiculos") || "[]");
    const equipos = JSON.parse(localStorage.getItem("recursosEquipos") || "[]");

    const cuit = localStorage.getItem("cuit");
    if (!cuit) return;

    fetch(`/api/userinfo/${cuit}`)
      .then((res) => res.json())
      .then((data) => {
        const desc = data.descripcionServicio?.trim();
        const alcance = data.alcanceServicio?.trim();
        const forma = data.formaJuridica?.trim();

        setDescripcionServicio(desc);
        setAlcanceServicio(alcance);
        setFormaJuridica(forma);

        const empresa = documentosData.filter(doc =>
          doc.aplicaA === "empresa" &&
          doc.formaJuridica?.trim() === forma &&
          doc.aplica?.includes(desc) &&
          !(alcance === "Recurso no Ingresa a Sitio" && doc.excluirSiNoIngresa)
        );

        const trabajadoresDocs = [];
        trabajadores.forEach((trabajador, i) => {
          documentosData.forEach((doc, j) => {
            if (
              doc.aplicaA === "trabajador" &&
              doc.formaJuridica?.trim() === forma &&
              doc.aplica?.includes(desc) &&
              !(alcance === "Recurso no Ingresa a Sitio" && doc.excluirSiNoIngresa)
            ) {
              trabajadoresDocs.push({
                ...doc,
                key: `trabajador_${i}_${j}`,
                identificador: `Trabajador ${i + 1} - DNI ${trabajador["DNI"] || ""}`,
                dni: trabajador["DNI"]
              });
            }
          });
        });

        const vehiculosDocs = [];
        vehiculos.forEach((vehiculo, i) => {
          documentosData.forEach((doc, j) => {
            if (
              doc.aplicaA === "vehiculo" &&
              doc.formaJuridica?.trim() === forma &&
              doc.aplica?.includes(desc) &&
              !(alcance === "Recurso no Ingresa a Sitio" && doc.excluirSiNoIngresa)
            ) {
              vehiculosDocs.push({
                ...doc,
                key: `vehiculo_${i}_${j}`,
                identificador: `Vehículo ${i + 1} - Patente ${vehiculo["Dominio / Patente"] || ""}`,
                patente: vehiculo["Dominio / Patente"]
              });
            }
          });
        });

        const equiposDocs = [];
        equipos.forEach((equipo, i) => {
          documentosData.forEach((doc, j) => {
            if (
              doc.aplicaA === "equipo" &&
              doc.formaJuridica?.trim() === forma &&
              doc.aplica?.includes(desc) &&
              !(alcance === "Recurso no Ingresa a Sitio" && doc.excluirSiNoIngresa)
            ) {
              equiposDocs.push({
                ...doc,
                key: `equipo_${i}_${j}`,
                identificador: `Equipo ${i + 1} - Patente ${equipo["Dominio / Patente"] || ""}`,
                patente: equipo["Dominio / Patente"]
              });
            }
          });
        });

        setDocumentosFiltrados({
          empresa: empresa.map((doc, i) => ({ ...doc, key: `empresa_${i}` })),
          trabajadores: trabajadoresDocs,
          vehiculos: vehiculosDocs,
          equipos: equiposDocs,
        });
      })
      .catch((err) => {
        console.error("❌ Error al obtener datos de usuario desde Sheets:", err);
      });
  }, []);

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    setFormTouched(true);
    if (!file) return; // Solo actualiza si hay archivo
    setUploadedFiles((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        file,
        fechaSubida: dayjs().format("YYYY-MM-DD"),
      },
    }));
  };

  const handleFechaVencimiento = (e, key) => {
    const fecha = e.target.value;
    setFormTouched(true);
    setUploadedFiles((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        fechaVencimiento: fecha,
      },
    }));
  };

  const handleEnviar = async () => {
    const formData = new FormData();
    const idRegistro = localStorage.getItem("idRegistro");
    if (!idRegistro) {
      alert("❌ No se encontró el ID de registro.");
      return;
    }

    const todosLosDocs = [
      ...documentosFiltrados.empresa,
      ...documentosFiltrados.trabajadores,
      ...documentosFiltrados.vehiculos,
      ...documentosFiltrados.equipos
    ];

    const nuevosErrores = {};
    let hayErrores = false;

    todosLosDocs.forEach((doc) => {
      const fileData = uploadedFiles[doc.key];
      if (!fileData?.file) {
        nuevosErrores[doc.key] = { ...(nuevosErrores[doc.key] || {}), file: true };
        hayErrores = true;
      }
      if (doc.tipoPresentacion?.toUpperCase() !== "ÚNICA VEZ" && doc.tipoPresentacion?.trim() !== "") {
        if (!fileData?.fechaVencimiento) {
          nuevosErrores[doc.key] = { ...(nuevosErrores[doc.key] || {}), fecha: true };
          hayErrores = true;
        }
      }
    });

    if (hayErrores) {
      setErroresDocumentos(nuevosErrores);
      alert("⚠️ Completá todos los campos obligatorios antes de continuar.");
      return;
    }

    formData.append("idRegistro", idRegistro);

    const recursosRes = await fetch(`/api/recursosByRegistro/${idRegistro}`);
    const recursos = await recursosRes.json();

    const buscarIdRecurso = (doc) => {
      if (doc.dni) {
        return recursos.trabajadores.find(r => r.dni === doc.dni)?.id || null;
      }
      if (doc.patente) {
        if (doc.identificador?.includes("Vehículo")) {
          return recursos.vehiculos.find(r => r.patente === doc.patente)?.id || null;
        }
        if (doc.identificador?.includes("Equipo")) {
          return recursos.equipos.find(r => r.patente === doc.patente)?.id || null;
        }
      }
      return null;
    };

    todosLosDocs.forEach((doc) => {
      const fileData = uploadedFiles[doc.key];
      formData.append("documentos", JSON.stringify({
        nombreDocumento: doc.nombre,
        fechaSubida: fileData.fechaSubida,
        fechaVencimiento: fileData.fechaVencimiento || "",
        recursoId: buscarIdRecurso(doc)
      }));
      formData.append("archivos", fileData.file);
    });

    try {
      setEnviando(true);
      const res = await fetch("/api/subirDocumentos", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
        setShowModal(true);
        setErroresDocumentos({});
      } else {
        alert("❌ Error al enviar documentos");
      }
    } catch (err) {
      console.error("❌ Error:", err);
      alert("❌ Error de conexión al servidor");
    } finally {
      setEnviando(false);
    }
  };
  
  const renderTablaDocumentos = (titulo, documentos) => {
    if (!documentos || documentos.length === 0) return null;
  
    return (
      <div style={{ marginBottom: "40px" }}>
        <h3 style={{ marginTop: "30px", color: "black" }}>{titulo}</h3>
        <table className="compact-table">
          <thead>
            <tr>
              <th>Documento a Presentar</th>
              <th>Tipo de Presentación</th>
              <th>Aplicado a</th>
              <th>Fecha de Subida</th>
              <th>Fecha de Vencimiento</th>
              <th>Archivo</th>
            </tr>
          </thead>
          <tbody>
            {documentos.map((doc) => (
              <tr key={doc.key}>
                <td>{doc.nombre}</td>
                <td>{doc.tipoPresentacion}</td>
                <td>
                  <strong style={{ fontSize: "0.9em", color: "#666" }}>
                    {doc.identificador || "-"}
                  </strong>
                </td>
                <td>{uploadedFiles[doc.key]?.fechaSubida || "-"}</td>
                <td>
                  {doc.tipoPresentacion?.toUpperCase() !== "ÚNICA VEZ" ? (
                    <input
                      type="date"
                      className={`input-field ${erroresDocumentos[doc.key]?.fecha ? "error" : ""}`}
                      onChange={(e) => handleFechaVencimiento(e, doc.key)}
                      value={uploadedFiles[doc.key]?.fechaVencimiento || ""}
                    />
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>
                  <input
                    type="file"
                    accept="application/pdf"
                    className={`input-field ${erroresDocumentos[doc.key]?.file ? "error" : ""}`}
                    onChange={(e) => handleFileChange(e, doc.key)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
  const confirmBack = () => {
    setShowBackModal(false);
    navigate("/gestionproveedoreshome");
  };

  return (
    <div className="documentacion-container">
      <h2>Documentación Requerida</h2>
      <p><strong>Descripción del Servicio:</strong> {descripcionServicio}</p>
      <p><strong>Alcance del Servicio:</strong> {alcanceServicio}</p>
      <p><strong>Forma Jurídica:</strong> {formaJuridica}</p>

      {renderTablaDocumentos("Documentación General de la Empresa", documentosFiltrados.empresa)}
      {renderTablaDocumentos("Documentación por Trabajador", documentosFiltrados.trabajadores)}
      {renderTablaDocumentos("Documentación por Vehículo", documentosFiltrados.vehiculos)}
      {renderTablaDocumentos("Documentación por Equipo", documentosFiltrados.equipos)}

      <div className="button-container">
        <button
          className="secondary-button"
          onClick={() => {
            if (formTouched) setShowBackModal(true);
            else navigate("/gestionproveedoreshome");
          }}
        >
          Volver
        </button>
        <button
          className="primary-button"
          onClick={handleEnviar}
          disabled={enviando}
        >
          {enviando ? "Enviando..." : "Enviar"}
        </button>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="check-icon">✔️</div>
            <p>Documentación enviada con éxito</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={() => {setShowModal(false); navigate("/gestionproveedoreshome"); }}>Aceptar</button>
            </div>
          </div>
        </div>
      )}

      {showBackModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">⚠️</div>
            <p>¿Deseás volver? Se perderán los datos ingresados.</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={confirmBack}>Sí, volver</button>
              <button className="no-btn" onClick={() => setShowBackModal(false)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
      {enviando && <HourglassPopup />}

    </div>
  );
};

const HourglassPopup = () => (
  <div className="modal-overlay">
    <div className="modal-content animated-popup">
      <div className="hourglass">⏳</div>
      <p>Enviando información. Espere por favor...</p>
    </div>
  </div>
);

export default DocumentacionCarga;




